export const ELECTRICAL_HERO_IMAGE = '/images/services/electrical/hero.webp';

const ELECTRICAL = '/images/services/electrical';

export const ELECTRICAL_SERVICE_IMAGES: Record<string, string> = {
  'outlet-switch-repair': `${ELECTRICAL}/outlet-switch-repair.webp`,
  'light-fixture-installation': `${ELECTRICAL}/light-fixture-installation.webp`,
  'ceiling-fan-installation': `${ELECTRICAL}/ceiling-fan-installation.webp`,
  'breaker-panel-inspection': `${ELECTRICAL}/breaker-panel-inspection.webp`,
  'appliance-electrical-connection': `${ELECTRICAL}/appliance-electrical-connection.webp`,
  'wiring-troubleshooting': `${ELECTRICAL}/wiring-troubleshooting.webp`,
  'smart-device-wiring': `${ELECTRICAL}/smart-device-wiring.webp`,
  'emergency-electrical-service': `${ELECTRICAL}/emergency-electrical-service.webp`,
};

export const ELECTRICAL_SERVICE_CARD_SUBTITLES: Record<string, string> = {
  'outlet-switch-repair': 'Outlets, switches, dimmers',
  'light-fixture-installation': 'Ceiling, pendant, wall lights',
  'ceiling-fan-installation': 'Fan wiring and mounting',
  'breaker-panel-inspection': 'Breaker trips and panel issues',
  'appliance-electrical-connection': 'Safe power connections',
  'wiring-troubleshooting': 'Testing, wiring, and faults',
  'smart-device-wiring': 'Smart switches, devices, and controls',
  'emergency-electrical-service': 'Sparks, outages, and urgent hazards',
};
